const GenderMap = (gender: string) => {
  if (gender == 'Male') {
    return 'ولد'
  }

  if (gender == 'Female') {
    return 'بنت'
  }
}

export default GenderMap
